import { mutate } from '@/runtime'
import type { PageResource } from '@/kinds/page/apply'
import { COVERS, type CoverName } from '@/kinds/page/covers'
import { Button, Sheet, cx } from '@/components/ui'

/** Built-in gradient covers; one tap sets it. */
export const CoverSheet = ({ page, onClose }: { page: PageResource; onClose: () => void }) => (
  <Sheet open onClose={onClose} title="Cover">
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="page-covers">
      {(Object.keys(COVERS) as CoverName[]).map((name) => (
        <button
          key={name}
          type="button"
          onClick={() => {
            void mutate.patch(page.id, { spec: { cover: name } })
            onClose()
          }}
          className={cx(
            'aspect-[16/9] rounded-lg overflow-hidden relative ring-2 ring-transparent hover:ring-accent',
            page.spec.cover === name && 'ring-accent',
          )}
          style={{ background: COVERS[name].css }}
          aria-label={COVERS[name].label}
        >
          <span className="absolute bottom-1 left-1.5 text-[11px] text-white/90 drop-shadow">
            {COVERS[name].label}
          </span>
        </button>
      ))}
    </div>
    {page.spec.cover && (
      <Button
        className="mt-3"
        onClick={() => {
          void mutate.patch(page.id, { spec: { cover: null } })
          onClose()
        }}
      >
        Remove cover
      </Button>
    )}
  </Sheet>
)
